import { loadKatex } from './config';

export function renderKatex(
  element,
  callBack = () => {
    console.log('renderKatex:: callback not defined');
  }
) {
  const processMath = () => {
    // console.log(element)
    try {
      window.renderMathInElement(element, {
        throwOnError: false,
      });
      callBack(element);
    } catch (e) {
      console.log(e);
    }
  };

  if (!window) return;

  if (window.renderMathInElement) {
    processMath();
    return;
  }

  // TAN-10415: si KaTeX aún no está en la página, cargarlo y renderizar después. Antes esta rama
  // no existía: se salía sin hacer nada y sin reintentar, así que la fórmula se quedaba en crudo
  // para siempre. No se notaba porque lemonade cargaba KaTeX por su cuenta y el script quedaba
  // disponible para todos; al pasar lemonade a MathJax dejó de haber quien lo cargase.
  loadKatex()
    .then(processMath)
    .catch((e) => console.log('error cargando Katex', e));
}
